export const environment = {
  production: false,
  keycloak: 'https://qa.accounts.propertymatrix.pepla.co.za:8443',
  keycloakrealm: 'property-matrix',
  keycloakclient: 'property-matrix-app',
  api: 'https://qa.api.propertymatrix.pepla.co.za',
  apiversion: "v1",
  riskscapeApiKey: "zIU3milsXyXVRYqib8lVKRTYBhSuhOKx",
  pageUrl: "https://qa.propertymatrix.pepla.co.za/#/",
  priceSliderMin: 1000000,
  priceSliderMax: 500000000
};
